import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getProjects } from "../requests/project";
import { Project } from "../types/project";

export const useGetProjects = (): UseQueryResult<Project[], AxiosError> =>
  useQuery(["getProjects"], getProjects);
